import { getAvailableBookingTimeslots_availableBookingTimes_timeSlots as TimeSlots } from './../../hooks';

export default (locale: string, timeSlots?: TimeSlots[]) => {
  if (!timeSlots || timeSlots?.length === 0) return [];

  const dateWithoutTime = new Date().toISOString().split('T')[0];
  const firstItem = timeSlots[0].from.toLowerCase();
  if (firstItem.includes('am') || firstItem.includes('pm'))
    return timeSlots?.map(({ from }) => ({
      label: from,
      value: from,
    }));

  return timeSlots?.map(({ from }) => ({
    label: new Date(`${dateWithoutTime}T${from}Z`).toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h12',
      timeZone: 'UTC',
    }),
    value: from,
  }));
};
